var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgExternalLinkAlt = function SvgExternalLinkAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C86A3",
    d: "M8.438 5.625h-.313a.32.32 0 0 0-.312.313v3.007c0 .078-.06.117-.118.117h-6.64q-.117 0-.117-.117v-6.64c0-.059.039-.118.117-.118h3.008a.32.32 0 0 0 .312-.312v-.312a.336.336 0 0 0-.312-.313H.938A.94.94 0 0 0 0 2.188v6.874C0 9.59.41 10 .938 10h6.875c.507 0 .937-.41.937-.937V5.937a.336.336 0 0 0-.312-.312M9.766 0H7.109c-.136.02-.234.117-.234.234q0 .117.059.176l.937.938L2.56 6.66c-.04.059-.079.117-.079.176s.04.117.079.156l.449.45c.039.038.097.078.156.078s.117-.04.176-.079L8.652 2.13l.938.937c.039.04.098.059.156.059.137 0 .234-.098.254-.234V.234A.25.25 0 0 0 9.766 0"
  })));
};
var Memo = /*#__PURE__*/memo(SvgExternalLinkAlt);
export default Memo;